import { IconProps } from '@rsuite/icons/lib/Icon'
import React, { FC } from 'react'

const ExpandArrowIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="6"
    height="11"
    viewBox="0 0 6 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.487313 1.27738C0.630991 1.11803 0.865525 1.08884 1.04201 1.19764L1.10518 1.24492L5.48018 5.17525C5.65182 5.32945 5.6709 5.58539 5.53739 5.7622L5.48018 5.82444L1.10518 9.75477C0.925578 9.91611 0.648951 9.90158 0.487313 9.72231C0.343634 9.56295 0.339173 9.32708 0.466094 9.16331L0.519832 9.10557L4.533 5.49897L0.519832 1.89412C0.360189 1.7507 0.330947 1.51659 0.439944 1.34043L0.487313 1.27738Z"
      fill="#8E8E93"
      stroke="#8E8E93"
      strokeWidth="0.5"
    />
  </svg>
)

export default ExpandArrowIcon
